export enum DialogTemplateStyleEnum {
  DEFAULT = 'DEFAULT',
  FLAT = 'FLAT',
}
